//
// user.js
// Use this to write your custom JS
//

import Chart from 'chart.js';
import './chart';

import moment from 'moment';

// Total Transaction Amount chart
const totalTransactionAmountChart = document.getElementById('totalTransactionAmountChart');
var total_transaction_chart;

if (totalTransactionAmountChart) {
  $.ajax({
    type : "GET",
    url : "/get-transfer-chart-data",
    data : { type : "transaction" },
    success: function(data){

      // Hide spinner
      $("#totalTransSpinner").hide();

      // Show Chart 
      $("#totalTransactionAmountChart").show();

      var daily_trans_data = data.dailyTransactions;
      var weekly_trans_data = data.weeklyTransactions;
      var monthly_trans_data = data.monthlyTransactions;
      var yearly_trans_data = data.yearlyTransactions;


      var monthDates = [];
      var lastMonthDate = parseInt(moment().endOf("month").format("D"));

      var currentDate;
      for(var i = 0; i  < lastMonthDate; i++){
        currentDate = i + 1;
        currentDate = currentDate.toString();
        monthDates.push(currentDate);
      };

      new Chart(totalTransactionAmountChart, {
        type: 'line',
        options: {
          animation: {
            duration: 400 // Make animations a bit more snappy
          },
          scales: {
            yAxes: [{
              id: 'yAxisOne',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisTwo',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  10,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisThree',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            }],
            xAxes: [{
              id: "xAxisOne",
              type: "category",
              display: 'auto',
              labels: ["12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"]
            },
            {
              id: "xAxisTwo",
              type: "category",
              display: 'auto',
              labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
            },
            {
              id: "xAxisThree",
              type: "category",
              display: 'auto',
              labels: monthDates
            },
            {
              id: "xAxisFour",
              type: "category",
              display: 'auto',
              labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            },
            {
              id: "xAxisFive",
              type: "category",
              display: 'auto',
              ticks: {
                maxTicksLimit: 15
              }
            }]
          }
        },
        data: {
          datasets: [{
            label: 'Today',
            data: daily_trans_data,
            yAxisID: 'yAxisOne',
            xAxisID: 'xAxisOne'
          }, {
            label: 'This Week',
            data: weekly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisTwo',
            hidden: true
          }, {
            label: 'This Month',
            data: monthly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisThree',
            hidden: true
          }, {
            label: 'This Year',
            data: yearly_trans_data,
            yAxisID: 'yAxisThree',
            xAxisID: 'xAxisFour',
            hidden: true
          }, {
            label: 'Custom Date Range',
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisFive',
            hidden: true
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });
  
};

// Total Revenue Amount chart

const totalRevenueAmountChart = document.getElementById('totalRevenueAmountChart');

if (totalRevenueAmountChart) {
  $.ajax({
    type : "GET",
    url : "/get-revenue-chart-data",
    success: function(data){

      // Hide spinner
      $("#totalRevSpinner").hide();

      // Show Chart 
      $("#totalRevenueAmountChart").show();

      var daily_rev_data = data.dailyRevenues;
      var weekly_rev_data = data.weeklyRevenues;
      var monthly_rev_data = data.monthlyRevenues;
      var yearly_rev_data = data.yearlyRevenues;

      var monthDates = [];
      var lastMonthDate = parseInt(moment().endOf("month").format("D"));

      var currentDate;
      for(var i = 0; i  < lastMonthDate; i++){
        currentDate = i + 1;
        currentDate = currentDate.toString();
        monthDates.push(currentDate);
      };

      new Chart(totalRevenueAmountChart, {
        type: 'line',
        options: {
          // elements: {
          //   line: {
          //     borderColor: "#e22224"
          //   }
          // },
          animation: {
            duration: 400 // Make animations a bit more snappy
          },
          scales: {
            yAxes: [{
              id: 'yAxisOne',
              type: 'linear',
              display: 'auto',
              // gridLines: {
              //   color: '#8a0507',
              //   zeroLineColor: '#720304'
              // },
              ticks: {
                // fontColor: "#ffffff93",
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisTwo',
              type: 'linear',
              display: 'auto',
              // gridLines: {
              //   color: '#8a0507',
              //   zeroLineColor: '#720304'
              // },
              ticks: {
                // fontColor: "#ffffff93",
                maxTicksLimit:  10,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisThree',
              type: 'linear',
              display: 'auto',
              // gridLines: {
              //   color: '#8a0507',
              //   zeroLineColor: '#720304'
              // },
              ticks: {
                // fontColor: "#ffffff93",
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            }],
            xAxes: [{
              id: "xAxisOne",
              type: "category",
              display: 'auto',
              // ticks: {
              //   fontColor: "#ffffff93",
              // },
              labels: ["12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"]
            },
            {
              id: "xAxisTwo",
              type: "category",
              display: 'auto',
              // ticks: {
              //   fontColor: "#ffffff93",
              // },
              labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
            },
            {
              id: "xAxisThree",
              type: "category",
              display: 'auto',
              // ticks: {
              //   fontColor: "#ffffff93",
              // },
              labels: monthDates
            },
            {
              id: "xAxisFour",
              type: "category",
              display: 'auto',
              // ticks: {
              //   fontColor: "#ffffff93",
              // },
              labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            },
            {
              id: "xAxisFive",
              type: "category",
              display: 'auto',
              ticks: {
                maxTicksLimit: 15
              }
            }]
          }
        },
        data: {
          datasets: [{
            label: 'Today',
            data: daily_rev_data,
            yAxisID: 'yAxisOne',
            xAxisID: 'xAxisOne'
          }, {
            label: 'This Week',
            data: weekly_rev_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisTwo',
            hidden: true
          }, {
            label: 'This Month',
            data: monthly_rev_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisThree',
            hidden: true
          }, {
            label: 'This Year',
            data: yearly_rev_data,
            yAxisID: 'yAxisThree',
            xAxisID: 'xAxisFour',
            hidden: true
          }, {
            label: 'Custom Date Range',
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisFive',
            hidden: true
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });
};

// Total Amount Bar chart

const totalAmountBarChart = document.getElementById('totalAmountBarChart');

if (totalAmountBarChart) {
  $.ajax({
    type : "GET",
    url : "/get-tot-amount-bar-chart-data",
    success: function(data){

      // Hide spinner
      $("#totalTransBarSpinner").hide();

      // Show Chart 
      $("#totalAmountBarChart").show();
      
      var yearly_trans_data = data.yearlyTransactions;

      new Chart(totalAmountBarChart, {
        type: 'bar',
        options: {
          scales: {
            yAxes: [{
              ticks: {
                maxTicksLimit: 11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            }]
          }
        },
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [{
            label: 'Total Transactions',
            data: yearly_trans_data
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });
};

// Payment Channel chart

const paymentChannelsChart = document.getElementById('paymentChannelsChart');

if (paymentChannelsChart) {

  $.ajax({
    type : "GET",
    url : "/get-payment-channel-data",
    success: function(data){

      // Hide spinner
      $("#paymentChannelSpinner").hide();

      // Show Chart 
      $("#paymentChannelsChart").show();

      var channel_data = data;

      new Chart(paymentChannelsChart, {
        type: 'doughnut',
        options: {
          tooltips: {
            callbacks: {
              afterLabel: function() {
                return '%'
              }
            }
          }
        },
        data: {
          labels: ['Card', 'Momo'],
          datasets: [{
            data: channel_data,
            backgroundColor: ['#2c7be5', '#f6c343']
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });

};

// Total User Transactions Amount chart
const totalUserTransactionAmountChart = document.getElementById('totalUserTransactionAmountChart');

if (totalUserTransactionAmountChart) {
  var client_id = $("#chart-client-id").val();
  $.ajax({
    type : "GET",
    url : `/get-user-transfer-chart-data?id=${client_id}`,
    data : { type : "transaction" },
    success: function(data){

      // Hide spinner
      $("#totalTransSpinner").hide();

      // Show Chart 
      $("#totalUserTransactionAmountChart").show();

      var daily_trans_data = data.dailyTransactions;
      var weekly_trans_data = data.weeklyTransactions;
      var monthly_trans_data = data.monthlyTransactions;
      var yearly_trans_data = data.yearlyTransactions;

      var monthDates = [];
      var lastMonthDate = parseInt(moment().endOf("month").format("D"));

      var currentDate;
      for(var i = 0; i  < lastMonthDate; i++){
        currentDate = i + 1;
        currentDate = currentDate.toString();
        monthDates.push(currentDate);
      };

      new Chart(totalUserTransactionAmountChart, {
        type: 'line',
        options: {
          animation: {
            duration: 400 // Make animations a bit more snappy
          },
          scales: {
            yAxes: [{
              id: 'yAxisOne',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisTwo',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  10,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisThree',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            }],
            xAxes: [{
              id: "xAxisOne",
              type: "category",
              display: 'auto',
              labels: ["12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"]
            },
            {
              id: "xAxisTwo",
              type: "category",
              display: 'auto',
              labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
            },
            {
              id: "xAxisThree",
              type: "category",
              display: 'auto',
              labels: monthDates
            },
            {
              id: "xAxisFour",
              type: "category",
              display: 'auto',
              labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            },
            {
              id: "xAxisFive",
              type: "category",
              display: 'auto',
              ticks: {
                maxTicksLimit: 15
              }
            }]
          }
        },
        data: {
          datasets: [{
            label: 'Today',
            data: daily_trans_data,
            yAxisID: 'yAxisOne',
            xAxisID: 'xAxisOne'
          }, {
            label: 'This Week',
            data: weekly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisTwo',
            hidden: true
          }, {
            label: 'This Month',
            data: monthly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisThree',
            hidden: true
          }, {
            label: 'This Year',
            data: yearly_trans_data,
            yAxisID: 'yAxisThree',
            xAxisID: 'xAxisFour',
            hidden: true
          }, {
            label: 'Custom Date Range',
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisFive',
            hidden: true
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });
  
};

//Dashboard Card Values
const totalTransAmount = document.getElementById("totalTransAmount");
if(totalTransAmount){
  $.ajax({
    type : "GET",
    url : "/get_transactions_data",
    success: function(result){
        $("#totalTransAmount").html(result.transAmountSum);
        $("#totalTransCount").html(result.transCount);
        $("#todayAmountSum").html(result.todayTransAmountSum);
        $("#totalRevAmount").html(result.totalRevAmount);
        $("#todayRevSum").html(result.todayRevAmount);
    },
    error : function(err) {
        
    }
  });
}

const clientsCount = document.getElementById("clientsCount");
if(clientsCount){
  $.ajax({
    type : "GET",
    url : "/get_clients_data",
    success: function(result){
        $('#clientsCount').empty();
        $("#clientsCount").append(result.clientsCount);
    },
    error : function(err) {
        
    }
});
}
/* 
const lastTransList = document.getElementById("lastTransList");
if(lastTransList){
  $.ajax({
    type : "GET",
    url : "/get_lastest_trans",
    success: function(result){
      console.log(result, " wow");
      $('#lastTransList tbody').empty();
      $.each(result.latestTrans, function(i, transaction){
        if(transaction.trans_id != null || transaction.trans_id != undefined){
        var status_type = "";
        if((transaction.status ? transaction.status.toLowerCase() : "") == 'success'){
          status_type = 'success';
        }
        else if((transaction.status ? transaction.status.toLowerCase() : "") == 'failed'){
          status_type = 'danger';
        }
        else if((transaction.status ? transaction.status.toLowerCase() : "") == 'pending'){
          status_type = 'warning';
        }
        else{
          status_type = 'info';
        }

        var isFlagged = "";
        var flag_status = "";
        if(transaction.flag_status == "Y"){
            isFlagged = 'danger';
            flag_status = 'Flagged';
        }
        else if(transaction.flag_status == "N"){
            isFlagged = 'success';
            flag_status = 'Not Flagged';
        };

        // var product = "<td class='transaction-trans_type'><div class='d-flex align-items-center'><div class='avatar'><img class='avatar-img rounded mr-3' src='assets/img/avatars/products/product-1.jpg' alt='...' /></div><div class='ml-3'><h4 class='font-weight-normal mb-1'>Sketchpad</h4><small class='text-muted'>3 x 5 Size</small></div></div></td>";
        var clientname;

        if(transaction.clientInfo.acc_type){
          if(transaction.clientInfo.acc_type == 'individual'){
            clientname = "<td class='transaction-user'><a class='text-reset' href='/client-profile?id=" + transaction.userID + "'>" + transaction.clientInfo.first_name + " " + transaction.clientInfo.last_name + "</a></td>";
          }
          else if(transaction.clientInfo.acc_type == 'business'){
            clientname = "<td class='transaction-user'><a class='text-reset' href='/client-profile?id=" + transaction.userID + "'>" + transaction.clientInfo.busines_name + "</a></td>";
          }
        }
        else
        {
          clientname = "<td class='transaction-user'><a class='text-reset' href='/customer-profile?id=" + transaction.userID + "'>" + transaction.clientInfo.first_name + " " + transaction.clientInfo.last_name + "</a></td>";
        }

        var action = "";
        if(transaction.status ? (transaction.status.toLowerCase() != "success") : true){
          action = `
            <button type="button" class="btn btn-sm btn-white check-status-btn" data-trans-id="${transaction.trans_id}" data-trans-type="${transaction.trans_type}" style="width:110px;">
              Check Status
            </button>
          `;
        }

        // var trans_type = "<td class='transaction-trans_type'>" + transaction.trans_type + "</td>";
        var channel = "";
        if(!["remittance", "remitance"].includes(transaction.trans_type)){
          channel = `
            <td class='transaction-channel'>
              ${transaction.channel} <br/>
              <span class="text-muted small">
              ${
                transaction.channel == "Mobile Money" ? ((transaction.phoneNumber || "")  + "  " + (transaction.provider || "")) :
                ["bank","Bank Transfer"].includes(transaction.channel) ? ((transaction.account_number || "") + " " + (transaction.bank_code || "")) :
                transaction.channel == "Card" ? (transaction.customerEmail || "") : ""
              }
              ${
                transaction.pay_source ? `<br/><span class='text-muted'>${transaction.pay_source}</span>` : ""
              }
              </span>
            </td>
          `;
        }
        else{
          channel = `
            <td class='transaction-channel'>
              ${transaction.channel} <br/>
              <span class="text-muted small">
              ${
                transaction.channel == "Mobile Money" ? (transaction.rec_phoneNumber ||  + "  " + transaction.rec_provider) :
                ["bank","Bank Transfer"].includes(transaction.channel) ? (transaction.rec_bankNumber || "") : ""
              }
              </span>
            </td>
          `;
        }
        var amount = `
          <td class='transaction-amount'>
            ${(transaction.amount || transaction.amountSent || 0)} <br/>
            <span class="text-muted small">Charge - ${transaction.ourCharge}</span>
          </td>`;
        var elevy = `
          <td class='transaction-elevy'>
            ${(transaction.elevyAmt || 0)}
          </td>`;
        var transactionID = `
          <td>
            <a class='transaction-trans_id text-reset' href='/transaction-info?id=${transaction._id}'>${(transaction.trans_id || transaction.transID)}</a> <br/>
            ${transaction.partnerTransID ? ('<span class="text-muted small">' + transaction.partnerTransID + '</span><br/>') : ""}
            <span class="text-muted small">${transaction.trans_type} ${transaction.gateway ? ("- " + transaction.gateway) : ""}</span>
          </td>
        `;
        var status = `
          <td class='transaction-status'>
            <span class='badge bg-soft-${status_type}'>${(transaction.status ? transaction.status.toLowerCase() : "")}</span><br/>
            <span class='badge bg-soft-${isFlagged}'>${flag_status}</span>
          </td>
        `;
        var action_td = `
          <td class='transaction-action'>${action}</td>
        `;
        // var flagged = "<td class='transaction-flagged'><span class='badge bg-soft-" + isFlagged + "'>" + flag_status + "</span></td>";
        var date = "<td><time class='transaction-date' datetime='" + transaction.date.html_date + "'>" + transaction.date.html_date + "</time><p class='text-muted mb-0'>" + transaction.date.time + "</p></td>";
        var value_date = "<td class='transaction-value-date'></td>"
        if(transaction.value_date){
          value_date = "<td><time class='transaction-value-date' datetime='" + transaction.value_date.html_date + "'>" + transaction.value_date.html_date + "</time><p class='text-muted mb-0'>" + transaction.value_date.time + "</p></td>";
        };
        $('#lastTransList tbody').append("<tr>" + date + value_date + transactionID + clientname + channel + amount + elevy + status + action_td + "</tr>")
      }
      });
        
    },
    error : function(err) {
        
    }
  });
} */

// Total Customer Transaction Amount chart
const totalCustomerTransAmountChart = document.getElementById('totalCustomerTransAmountChart');

if (totalCustomerTransAmountChart) {

  var customer_id = $("#customer_id").val();

  $.ajax({
    type : "GET",
    url : `/get-chart-data?type=transaction&customer_id=${customer_id}`,
    data : { type : "transaction" },
    success: function(data){

      // Hide spinner
      $("#totalCustomerTransSpinner").hide();

      // Show Chart 
      $("#totalCustomerTransAmountChart").show();

      var daily_trans_data = data.dailyTransactions;
      var weekly_trans_data = data.weeklyTransactions;
      var monthly_trans_data = data.monthlyTransactions;
      var yearly_trans_data = data.yearlyTransactions;

      var monthDates = [];
      var lastMonthDate = parseInt(moment().endOf("month").format("D"));

      var currentDate;
      for(var i = 0; i  < lastMonthDate; i++){
        currentDate = i + 1;
        currentDate = currentDate.toString();
        monthDates.push(currentDate);
      };

      new Chart(totalCustomerTransAmountChart, {
        type: 'line',
        options: {
          animation: {
            duration: 400 // Make animations a bit more snappy
          },
          scales: {
            yAxes: [{
              id: 'yAxisOne',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisTwo',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  10,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            },{
              id: 'yAxisThree',
              type: 'linear',
              display: 'auto',
              gridLines: {
                color: '#283E59',
                zeroLineColor: '#283E59'
              },
              ticks: {
                maxTicksLimit:  11,
                callback: function(value) {
                  return '₵' + value;
                }
              }
            }],
            xAxes: [{
              id: "xAxisOne",
              type: "category",
              display: 'auto',
              labels: ["12AM", "1AM", "2AM", "3AM", "4AM", "5AM", "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"]
            },
            {
              id: "xAxisTwo",
              type: "category",
              display: 'auto',
              labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
            },
            {
              id: "xAxisThree",
              type: "category",
              display: 'auto',
              labels: monthDates
            },
            {
              id: "xAxisFour",
              type: "category",
              display: 'auto',
              labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            }]
          }
        },
        data: {
          datasets: [{
            label: 'Today',
            data: daily_trans_data,
            yAxisID: 'yAxisOne',
            xAxisID: 'xAxisOne'
          }, {
            label: 'This Week',
            data: weekly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisTwo',
            hidden: true
          }, {
            label: 'This Month',
            data: monthly_trans_data,
            yAxisID: 'yAxisTwo',
            xAxisID: 'xAxisThree',
            hidden: true
          }, {
            label: 'This Year',
            data: yearly_trans_data,
            yAxisID: 'yAxisThree',
            xAxisID: 'xAxisFour',
            hidden: true
          }]
        }
      });
    },
    error : function(err) {
      
    }
  });
  
};



// Convertions chart

const conversionsChart = document.getElementById('conversionsChart');

if (conversionsChart) {
  new Chart(conversionsChart, {
    type: 'bar',
    options: {
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return value + '%';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Oct 1', 'Oct 2', 'Oct 3', 'Oct 4', 'Oct 5', 'Oct 6', 'Oct 7', 'Oct 8', 'Oct 9', 'Oct 10', 'Oct 11', 'Oct 12'],
      datasets: [{
        label: '2020',
        data: [25, 20, 30, 22, 17, 10, 18, 26, 28, 26, 20, 32]
      }, {
        label: '2019',
        data: [15, 10, 20, 12, 7, 0, 8, 16, 18, 16, 10, 22],
        backgroundColor: '#d2ddec',
        hidden: true
      }]
    }
  });
}

// Traffic chart (alt)

const trafficChartAlt = document.getElementById('trafficChartAlt');

if (trafficChartAlt) {
  new Chart(trafficChartAlt, {
    type: 'doughnut',
    options: {
      tooltips: {
        callbacks: {
          afterLabel: function() {
            return '%'
          }
        }
      }
    },
    data: {
      labels: ['Direct', 'Organic', 'Referral'],
      datasets: [{
        data: [60, 25, 15],
        backgroundColor: ['#2C7BE5', '#A6C5F7', '#D2DDEC']
      }, {
        data: [15, 45, 20],
        backgroundColor: ['#2C7BE5', '#A6C5F7', '#D2DDEC'],
        hidden: true
      }]
    }
  });
}

// Sales chart

const salesChart = document.getElementById('salesChart');

if (salesChart) {
  new Chart(salesChart, {
    type: 'line',
    options: {
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return '$' + value + 'k';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Oct 1', 'Oct 3', 'Oct 6', 'Oct 9', 'Oct 12', 'Oct 5', 'Oct 18', 'Oct 21', 'Oct 24', 'Oct 27', 'Oct 30'],
      datasets: [{
        label: 'All',
        data: [0, 10, 5, 15, 10, 20, 15, 25, 20, 30, 25]
      }, {
        label: 'Direct',
        data: [7, 40, 12, 27, 34, 17, 19, 30, 28, 32, 24],
        hidden: true
      }, {
        label: 'Organic',
        data: [2, 12, 35, 25, 36, 25, 34, 16, 4, 14, 15],
        hidden: true
      }]
    }
  });
}

// Orders chart

const ordersChart = document.getElementById('ordersChart');

if (ordersChart) {
  new Chart(ordersChart, {
    type: 'bar',
    options: {
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return '$' + value + 'k';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [{
        label: 'Sales',
        data: [25, 20, 30, 22, 17, 10, 18, 26, 28, 26, 20, 32]
      }, {
        label: 'Affiliate',
        data: [15, 10, 20, 12, 7, 0, 8, 16, 18, 16, 10, 22],
        backgroundColor: '#d2ddec',
        hidden: true
      }]
    }
  });
}

// Earnings chart

const earningsChart = document.getElementById('earningsChart');

if (earningsChart) {
  new Chart(earningsChart, {
    type: 'bar',
    options: {
      scales: {
        yAxes: [{
          id: 'yAxisOne',
          type: 'linear',
          display: 'auto',
          ticks: {
            callback: function(value) {
              return '$' + value + 'k';
            }
          }
        }, {
          id: 'yAxisTwo',
          type: 'linear',
          display: 'auto',
          ticks: {
            callback: function(value) {
              return value + 'k';
            }
          }
        }, {
          id: 'yAxisThree',
          type: 'linear',
          display: 'auto',
          ticks: {
            callback: function(value) {
              return value + '%';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      datasets: [{
        label: 'Earnings',
        data: [18, 10, 5, 15, 10, 20, 15, 25, 20, 26, 25, 29, 18, 10, 5, 15, 10, 20],
        yAxisID: 'yAxisOne'
      }, {
        label: 'Sessions',
        data: [50, 75, 35, 25, 55, 87, 67, 53, 25, 80, 87, 45, 50, 75, 35, 25, 55, 19],
        yAxisID: 'yAxisTwo',
        hidden: true
      }, {
        label: 'Bounce',
        data: [40, 57, 25, 50, 57, 32, 46, 28, 59, 34, 52, 48, 40, 57, 25, 50, 57, 29],
        yAxisID: 'yAxisThree',
        hidden: true
      }]
    }
  });
}

// Weekly hours chart

const weeklyHoursChart = document.getElementById('weeklyHoursChart');

if (weeklyHoursChart) {
  new Chart(weeklyHoursChart, {
    type: 'bar',
    options: {
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return value + 'hrs';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      datasets: [{
        data: [21, 12, 28, 15, 5, 12, 17, 2]
      }]
    }
  });
}

// Overview chart

const overviewChart = document.getElementById('overviewChart');

if (overviewChart) {
  new Chart(overviewChart, {
    type: 'line',
    options: {
      scales: {
        yAxes: [{
          id: 'yAxisOne',
          type: 'linear',
          display: 'auto',
          ticks: {
            callback: function(value) {
              return '$' + value + 'k';
            }
          }
        }, {
          id: 'yAxisTwo',
          type: 'linear',
          display: 'auto',
          ticks: {
            callback: function(value) {
              return value + 'hrs';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [{
        label: 'Earned',
        data: [0, 10, 5, 15, 10, 20, 15, 25, 20, 30, 25, 40],
        yAxisID: 'yAxisOne'
      }, {
        label: 'Hours Worked',
        data: [7, 35, 12, 27, 34, 17, 19, 30, 28, 32, 24, 39],
        yAxisID: 'yAxisTwo',
        hidden: true
      }]
    }
  });
}

// Sparkline chart

const sparklineChart = document.getElementById('sparklineChart');

if (sparklineChart) {
  new Chart(sparklineChart, {
    type: 'line',
    options: {
      scales: {
        yAxes: [{
          display: false
        }],
        xAxes: [{
          display: false
        }]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          hoverRadius: 0
        }
      },
      tooltips: {
        custom: function() {
          return false;
        }
      }
    },
    data: {
      labels: new Array(12),
      datasets: [{
        data: [0, 15, 10, 25, 30, 15, 40, 50, 80, 60, 55, 65]
      }]
    }
  });
}

// Sparkline chart (gray)

const sparklineCharts = document.querySelectorAll('#sparklineChartSocialOne, #sparklineChartSocialTwo, #sparklineChartSocialThree, #sparklineChartSocialFour');

if (sparklineCharts) {
  [].forEach.call(sparklineCharts, function(chart) {
    new Chart(chart, {
      type: 'line',
      options: {
        scales: {
          yAxes: [{
            display: false
          }],
          xAxes: [{
            display: false
          }]
        },
        elements: {
          line: {
            borderWidth: 2,
            borderColor: '#D2DDEC'
          },
          point: {
            hoverRadius: 0
          }
        },
        tooltips: {
          custom: function() {
            return false;
          }
        }
      },
      data: {
        labels: new Array(12),
        datasets: [{
          data: [0, 15, 10, 25, 30, 15, 40, 50, 80, 60, 55, 65]
        }]
      }
    });
  });
}

// Feed chart

const feedChart = document.getElementById('feedChart');

if (feedChart) {
  new Chart(feedChart, {
    type: 'bar',
    options: {
      scales: {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return '$' + value + 'k';
            }
          }
        }]
      }
    },
    data: {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [{
        label: 'Sales',
        data: [25, 20, 30, 22, 17, 10, 18, 26, 28, 26, 20, 32]
      }, {
        label: 'Affiliate',
        data: [15, 10, 20, 12, 7, 0, 8, 16, 18, 16, 10, 22],
        backgroundColor: '#d2ddec',
        hidden: true
      }]
    }
  });
}

var pathname = window.location.pathname;
if(!["/"].includes(pathname)){
  function logout(){
    window.location.href = "/log-out";
  }
  $.getScript("https://cdn.jsdelivr.net/npm/jquery.idle@1.3.0/jquery.idle.min.js", function () {
    $.getScript("https://momentjs.com/downloads/moment.min.js", function () {

      var timeoutModal = `
        <div class="modal fade" id="timeoutModal" tabindex="-1" role="dialog" aria-labelledby="timeoutModalTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:450px;">
            <div class="modal-content">
              <div class="modal-body text-center">
                <p>
                  You are about to be logged out for inactivity.
                </p>
                <button class="btn btn-juni-red" data-dismiss="modal" style="width: 100px;">
                  Stay
                </button>
              </div>
            </div>
          </div>
        </div>
    `;

      var setTimeoutAction;
      
      $(document).idle({
        onIdle: function () {
          
          if (!$("#timeoutModal").length) {
            
            $("body").append(timeoutModal);
          }
          if (!$("#timeoutModal").is(":visible")) {
            
            $("#timeoutModal").modal("show");
          }
          setTimeoutAction = setTimeout(function () {
            
            logout();
          }, 15000);
        },
        onActive: function () {
          
          if (setTimeoutAction) {
            clearTimeout(setTimeoutAction);
          }
        },
        events: 'mousemove mousedown click keydown touchstart',
        idle: 1 * 60 * 60 * 1000 // 1 hour
      });

    })
  });
}